var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:( _vm.title+' Oficial' ),expression:" title+' Oficial' "}]},[_c('i',{staticClass:"vtl vtl-oficial"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }